import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.monitoring');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-monitoring',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.monitoring/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMonitoringComponent implements OnInit {
    public filter: any = { issue: 'all', source: 'all', language: 'all', severity: 'all', status: 'all' };
    public selectedAlertId: string = 'alert-1';
    public detailTab: string = 'overview';
    public sortBy: string = 'date';
    public bookmarked: any = {};

    public issueOptions: any[] = [
        { id: 'all', label: '전체 이슈' }, { id: 'dokdo', label: '독도' },
        { id: 'eastsea', label: '동해' }, { id: 'comfort', label: '위안부' },
        { id: 'history', label: '역사 교과서' }, { id: 'territory', label: '영토 일반' }
    ];
    public sourceOptions: any[] = [
        { id: 'all', label: '전체 소스' }, { id: 'paper', label: '논문' },
        { id: 'news', label: '뉴스' }, { id: 'sns', label: 'SNS' },
        { id: 'wiki', label: '위키' }, { id: 'textbook', label: '교과서' },
        { id: 'gov', label: '정부 문서' }
    ];
    public langOptions: any[] = [
        { id: 'all', label: '전체 언어' }, { id: 'ko', label: '한국어' },
        { id: 'ja', label: '일본어' }, { id: 'zh', label: '중국어' },
        { id: 'en', label: '영어' }, { id: 'de', label: '독일어' }
    ];
    public severityOptions: any[] = [
        { id: 'all', label: '전체 등급' }, { id: 'high', label: '긴급' },
        { id: 'medium', label: '주의' }, { id: 'low', label: '참고' }
    ];

    public alerts: any[] = [
        {
            id: 'alert-1', issue: 'dokdo', severity: 'high',
            title: '영문 칼럼에서 독도를 일본 고유 영토로 표기',
            source: 'news', sourceName: 'Global Affairs Daily', lang: 'en',
            time: '09:12', date: '오늘', status: 'review',
            excerpt: 'Dokdo를 일본 고유 영토로 기술하고 현대 실효 지배를 일방적 재해석으로 프레이밍하는 영문 칼럼이 탐지되었습니다. 해당 기사는 국제 여론에 영향을 미칠 수 있는 주요 매체에서 게재되었으며, 신속한 검토와 대응이 필요합니다.',
            keywords: ['Dokdo', 'sovereignty', 'territorial', 'Liancourt Rocks'],
            evidence: [
                { title: '대한제국 칙령 제41호', note: '독도를 울도군 관할로 명시', score: 98 },
                { title: 'SCAPIN 제677호', note: '일본 행정권에서 독도 제외', score: 95 },
                { title: '동북아역사재단 사료 #D-12', note: '국제법 반박 문장 자동 추천', score: 91 },
                { title: '1877년 태정관 지령', note: '일본 정부 스스로 독도 제외 결정', score: 93 }
            ],
            rebuttal: '독도는 대한제국 칙령 제41호와 전후 처리 문서에서 한국 행정권과의 연속성이 확인되며, 일본 고유 영토 서술은 사료적 근거가 부족합니다.',
            spread: 2.3, matchCount: 4,
            relatedLinks: [
                { label: '원문 기사', url: '#' },
                { label: '이전 유사 사례 (2025-11)', url: '#' }
            ],
            trendData: [12, 18, 45, 62, 58, 71, 89],
            assignee: '김연구원'
        },
        {
            id: 'alert-2', issue: 'eastsea', severity: 'medium',
            title: '학술지 초록에서 Sea of Japan 단독 표기',
            source: 'paper', sourceName: 'Maritime History Review', lang: 'en',
            time: '07:48', date: '오늘', status: 'pending',
            excerpt: '초록에서 Sea of Japan을 단독 사용하면서 동아시아 역사 자료의 병기 맥락을 생략했습니다. 학술 영역에서 표기 편향이 정착될 우려가 있습니다.',
            keywords: ['Sea of Japan', 'East Sea', 'dual naming', 'IHO'],
            evidence: [
                { title: '국제수로기구 병기 논의 정리', note: '복수 표기 논의 경과', score: 89 },
                { title: '조선 후기 해도 사료', note: '동해 명칭 사용 사례', score: 92 },
                { title: '유럽 고지도 컬렉션', note: '18세기 이전 Sea of Korea 표기', score: 85 }
            ],
            rebuttal: 'East Sea 병기 논의는 국제 표준화 과정에서 지속 제기되어 왔으며, 단독 표기는 역사적 문맥을 축소할 위험이 있습니다.',
            spread: 1.1, matchCount: 3,
            relatedLinks: [
                { label: '학술지 원문', url: '#' }
            ],
            trendData: [5, 8, 12, 15, 14, 18, 22],
            assignee: '박연구원'
        },
        {
            id: 'alert-3', issue: 'comfort', severity: 'high',
            title: 'SNS 영상에서 위안부 강제성 부정',
            source: 'sns', sourceName: 'HistoryScope Channel', lang: 'ja',
            time: '22:31', date: '어제', status: 'done',
            excerpt: '위안부를 전시 노동 참여자로 프레이밍하면서 피해자 증언·군 문서에 기반한 강제 동원 맥락을 의도적으로 제거하고 있습니다.',
            keywords: ['comfort women', 'coercion', 'testimony', '慰安婦'],
            evidence: [
                { title: '피해자 증언 기록집', note: '강제 동원 진술 다수 수록', score: 97 },
                { title: '일본군 문서 아카이브', note: '운영 체계·관리 문서 존재', score: 94 },
                { title: '고노 담화 (1993)', note: '일본 정부의 공식 인정', score: 96 }
            ],
            rebuttal: '피해자 증언과 군 문서를 종합하면 강제성 부정은 핵심 사료를 누락한 해석입니다.',
            spread: 4.7, matchCount: 3,
            relatedLinks: [
                { label: '원본 영상', url: '#' },
                { label: '관련 반박 보고서', url: '#' }
            ],
            trendData: [25, 48, 92, 156, 134, 110, 88],
            assignee: '이연구원'
        },
        {
            id: 'alert-4', issue: 'dokdo', severity: 'medium',
            title: '위키피디아 Liancourt Rocks 문서 편집 전쟁',
            source: 'wiki', sourceName: 'Wikipedia EN', lang: 'en',
            time: '15:20', date: '어제', status: 'review',
            excerpt: '영문 위키피디아 Liancourt Rocks 문서에서 한국 측 근거 자료에 대한 반복적인 삭제 편집이 탐지되었습니다. 서술 중립성이 훼손되고 있으며 모니터링이 필요합니다.',
            keywords: ['Liancourt Rocks', 'Wikipedia', 'edit war', 'neutrality'],
            evidence: [
                { title: '위키 편집 이력 분석', note: '7일간 23회 되돌리기 감지', score: 88 },
                { title: '삭제된 출처 목록', note: '한국 측 학술 자료 5건 삭제됨', score: 82 }
            ],
            rebuttal: '위키피디아의 중립성 정책에 따라 양측 근거를 균형 있게 서술해야 하며, 일방적 삭제는 정책 위반입니다.',
            spread: 1.8, matchCount: 2,
            relatedLinks: [
                { label: '편집 이력', url: '#' }
            ],
            trendData: [3, 5, 8, 12, 18, 23, 19],
            assignee: '김연구원'
        },
        {
            id: 'alert-5', issue: 'history', severity: 'high',
            title: '일본 중학교 교과서에서 독도·위안부 서술 축소',
            source: 'textbook', sourceName: '검정 교과서 2026판', lang: 'ja',
            time: '11:05', date: '2일 전', status: 'review',
            excerpt: '2026년 검정 통과 중학교 사회 교과서에서 독도를 "일본 고유의 영토"로 명기하고, 위안부 관련 서술을 이전 판 대비 60% 축소했습니다.',
            keywords: ['교과서', '검정', '독도', '위안부', '서술 축소'],
            evidence: [
                { title: '2024판 vs 2026판 비교표', note: '위안부 서술 60% 축소', score: 99 },
                { title: '문부과학성 검정 기준', note: '영토 교육 강화 지침 반영', score: 90 },
                { title: '한국 교과서 대응 서술', note: '한국 측 교과서 기술과 비교', score: 86 },
                { title: 'UN 인권위원회 권고', note: '역사 교육 권고 사항', score: 91 }
            ],
            rebuttal: '역사적 사실의 축소·왜곡은 국제 인권 기준에 반하며, UN 인권위원회 역시 역사 교육의 정확성을 권고하고 있습니다.',
            spread: 3.5, matchCount: 4,
            relatedLinks: [
                { label: '교과서 원문 스캔', url: '#' },
                { label: '검정 결과 공고', url: '#' },
                { label: '과거 대응 사례', url: '#' }
            ],
            trendData: [8, 15, 32, 78, 120, 95, 105],
            assignee: '이연구원'
        },
        {
            id: 'alert-6', issue: 'territory', severity: 'low',
            title: '중국 학술지에서 간도 귀속 재해석 논문',
            source: 'paper', sourceName: 'Northeast Asian Studies', lang: 'zh',
            time: '18:40', date: '3일 전', status: 'pending',
            excerpt: '간도 지역의 역사적 귀속을 청-조선 국경 조약 해석을 중심으로 재구성하면서, 백두산정계비의 토문강 해석을 중국 측 입장으로 한정하고 있습니다.',
            keywords: ['간도', '백두산정계비', '토문강', '국경 조약'],
            evidence: [
                { title: '백두산정계비 판독 기록', note: '토문강=두만강 해석 반박', score: 84 },
                { title: '간도 협약 무효론', note: '1909년 조약의 법적 하자', score: 79 }
            ],
            rebuttal: '백두산정계비의 토문강 해석은 학계에서 여전히 논쟁 중이며, 일방적 해석은 사료 근거가 불충분합니다.',
            spread: 0.6, matchCount: 2,
            relatedLinks: [
                { label: '논문 원문', url: '#' }
            ],
            trendData: [2, 3, 4, 5, 4, 6, 7],
            assignee: '박연구원'
        },
        {
            id: 'alert-7', issue: 'eastsea', severity: 'medium',
            title: '독일 출판 세계지도에서 Sea of Japan 단독 표기',
            source: 'news', sourceName: 'Cartography Weekly', lang: 'de',
            time: '14:22', date: '오늘', status: 'pending',
            excerpt: '독일 주요 출판사의 2026년판 세계지도에서 동해를 Sea of Japan으로만 표기했습니다. 유럽 시장 내 표기 현황 모니터링이 필요합니다.',
            keywords: ['지도', 'Japanisches Meer', '병기', '유럽'],
            evidence: [
                { title: 'IHO S-130 결정문', note: '디지털 병기 방식 채택', score: 88 },
                { title: '유럽 지도 병기 현황 조사', note: '2025년 유럽 33개국 조사', score: 83 }
            ],
            rebuttal: '국제수로기구의 디지털 전환 결정에 따라, 출판물에서도 병기 방식을 채택해야 합니다.',
            spread: 0.9, matchCount: 2,
            relatedLinks: [
                { label: '출판사 연락처', url: '#' }
            ],
            trendData: [1, 2, 3, 5, 4, 6, 9],
            assignee: '박연구원'
        }
    ];

    public watchKeywords: any[] = [
        { keyword: 'Liancourt Rocks', hits: 23, trend: 'up' },
        { keyword: 'Sea of Japan', hits: 45, trend: 'up' },
        { keyword: 'comfort women voluntary', hits: 12, trend: 'down' },
        { keyword: '竹島 固有領土', hits: 18, trend: 'stable' },
        { keyword: '間島 中国領', hits: 8, trend: 'up' },
        { keyword: 'Dokdo dispute', hits: 31, trend: 'up' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (location.pathname === '/monitoring') {
            this.service.href('/radar');
            return;
        }
        await this.service.auth.allow('/access');
        await this.service.render();
    }

    public get filteredAlerts() {
        let list = this.alerts.filter((a: any) => {
            if (this.filter.issue !== 'all' && a.issue !== this.filter.issue) return false;
            if (this.filter.source !== 'all' && a.source !== this.filter.source) return false;
            if (this.filter.language !== 'all' && a.lang !== this.filter.language) return false;
            if (this.filter.severity !== 'all' && a.severity !== this.filter.severity) return false;
            if (this.filter.status !== 'all' && a.status !== this.filter.status) return false;
            return true;
        });
        if (this.sortBy === 'severity') {
            const order: any = { high: 0, medium: 1, low: 2 };
            list = [...list].sort((a: any, b: any) => (order[a.severity] ?? 3) - (order[b.severity] ?? 3));
        }
        return list;
    }

    public get selectedAlert() {
        return this.filteredAlerts.find((a: any) => a.id === this.selectedAlertId) || this.filteredAlerts[0] || null;
    }

    public get highCount() { return this.alerts.filter((a: any) => a.severity === 'high').length; }
    public get mediumCount() { return this.alerts.filter((a: any) => a.severity === 'medium').length; }
    public get lowCount() { return this.alerts.filter((a: any) => a.severity === 'low').length; }
    public get reviewCount() { return this.alerts.filter((a: any) => a.status === 'review').length; }
    public get pendingCount() { return this.alerts.filter((a: any) => a.status === 'pending').length; }
    public get doneCount() { return this.alerts.filter((a: any) => a.status === 'done').length; }

    public severityColor(level: string) {
        return { high: 'bg-red-500', medium: 'bg-amber-400', low: 'bg-stone-400' }[level] || 'bg-stone-300';
    }

    public severityLabel(level: string) {
        return { high: '긴급', medium: '주의', low: '참고' }[level] || level;
    }

    public severityBadge(level: string) {
        return {
            high: 'text-red-700 bg-red-50 dark:text-red-300 dark:bg-red-900/20',
            medium: 'text-amber-700 bg-amber-50 dark:text-amber-300 dark:bg-amber-900/20',
            low: 'text-stone-600 bg-stone-100 dark:text-stone-400 dark:bg-stone-800'
        }[level] || 'text-stone-600 bg-stone-100';
    }

    public sourceLabel(type: string) {
        return { paper: '논문', news: '뉴스', sns: 'SNS', wiki: '위키', textbook: '교과서', gov: '정부' }[type] || type;
    }

    public statusLabel(s: string) {
        return { review: '검토 중', pending: '대기', done: '대응 완료' }[s] || s;
    }

    public statusBadge(s: string) {
        return {
            review: 'text-blue-700 bg-blue-50 dark:text-blue-300 dark:bg-blue-900/20',
            pending: 'text-stone-600 bg-stone-100 dark:text-stone-400 dark:bg-stone-800',
            done: 'text-emerald-700 bg-emerald-50 dark:text-emerald-300 dark:bg-emerald-900/20'
        }[s] || 'text-stone-600 bg-stone-100';
    }

    public trendIcon(t: string) {
        return { up: '↑', down: '↓', stable: '→' }[t] || '→';
    }

    public trendColor(t: string) {
        return { up: 'text-red-500', down: 'text-emerald-500', stable: 'text-stone-400' }[t] || 'text-stone-400';
    }

    public isBookmarked(id: string) {
        return !!this.bookmarked[id];
    }

    public async toggleBookmark(id: string, event: any) {
        event.stopPropagation();
        this.bookmarked[id] = !this.bookmarked[id];
        await this.service.render();
    }

    public async setSort(sort: string) {
        this.sortBy = sort;
        await this.service.render();
    }

    public async setDetailTab(tab: string) {
        this.detailTab = tab;
        await this.service.render();
    }

    public async updateFilter() {
        if (!this.filteredAlerts.some((a: any) => a.id === this.selectedAlertId)) {
            this.selectedAlertId = this.filteredAlerts[0]?.id || '';
        }
        await this.service.render();
    }

    public async selectAlert(id: string) {
        this.selectedAlertId = id;
        this.detailTab = 'overview';
        await this.service.render();
    }

    public trendBarHeight(val: number, data: number[]) {
        const max = Math.max(...data);
        return max > 0 ? Math.round((val / max) * 100) : 0;
    }
}

export default PageMonitoringComponent;